"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GardenIcon = GardenIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function GardenIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.547 11.8206C17.3132 11.4698 17.5646 11 17.9862 11C18.4132 11 18.6635 10.5193 18.4186 10.1695L12.8221 2.17453C12.4232 1.60465 11.5788 1.60607 11.1818 2.17729L5.6168 10.1844C5.37751 10.5287 5.6239 11 6.04318 11C6.45516 11 6.70306 11.4568 6.47853 11.8022L4.10422 15.455C3.6718 16.1203 4.14922 17 4.94266 17H9.01998C9.57226 17 10.02 17.4477 10.02 18V20C10.02 20.5523 10.4677 21 11.02 21H12.98C13.5323 21 13.98 20.5523 13.98 20V18C13.98 17.4477 14.4277 17 14.98 17H19.1315C19.9302 17 20.4065 16.1099 19.9635 15.4453L17.547 11.8206Z",
    fill: "currentColor"
  }));
}